import { createSlice } from "@reduxjs/toolkit";
const initialState = {};

const dateRangeSlice = createSlice({
  name: "dateRange",
  initialState,
  reducers: {
    addDateRange(state, action) {
      const item = action.payload;
      state[item.id] = item;
    },
    removeDateRange(state, action) {
      delete state[action.payload];
    }
  }
});

export const { addDateRange, removeDateRange } = dateRangeSlice.actions;
export default dateRangeSlice.reducer;
